import { useState } from "react";
import AdminSidebar from "./AdminSidebar";

function AdminLayout({ children }) {

  const [open, setOpen] = useState(false);

  return (
    <div className="dashboard">
      <div className="admin-topbar">

      <button
        className="admin-menu-btn"
        onClick={() => setOpen(!open)}
      >
        ☰
      </button>
      </div>

      
      <AdminSidebar open={open} setOpen={setOpen} />

      <main className="main-content">
        {children}
      </main>

    </div>
  );
}

export default AdminLayout;